import React, { useContext } from 'react'
import YotpoStars from 'src/components/YotpoStars'
import theme from 'src/utils/styles/theme'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Analytics from 'src/utils/Analytics'
import { HiddenOnDesktop, HiddenOnMobile } from 'src/utils/styles/global-styles'
import PropTypes from 'prop-types'
import { BuyNowLink, BuyNowAnchor, ExternalLink } from '../Hero/styles'
import StoreContext from '../../context/StoreContext'

import {
  Heading,
  Container,
  ImageContainer,
  CtaContainer,
  LogoImageContainer,
  SubHeading,
  SyncsHeader,
  SyncsSection,
  Flexbox,
  TextContainer,
} from './styles'
import {
  BUY_LINK,
  CAL_BUY_LINK,
  FRAME_2_WALNUT_BUY_LINK,
  IS_FOREIGN_COUNTRY,
  IN_CA,
  IN_UK,
  IN_AU,
} from '../../utils/constants'

export default function HomepageCalHero({ page, amazon }) {
  const data = useStaticQuery(graphql`
    query HomepageCalHeroQuery {
      calBackground: file(relativePath: { eq: "homepage/calendar-on-counter-desktop.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundMD: file(relativePath: { eq: "homepage/calendar-on-counter-desktop-md.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundCalendarMD: file(
        relativePath: { eq: "homepage/calendar-on-counter-desktop-calendar-md.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frame2Background: file(relativePath: { eq: "frame2/frame-2-wood-mom-and-baby.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frame2MobileBackground: file(
        relativePath: { eq: "frame2/frame-2-wood-mom-and-baby-mobile.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      bts: file(relativePath: { eq: "bts/back-to-school-ca-calendar-frame.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      btsMobile: file(relativePath: { eq: "bts/back-to-school-ca-calendar-frame-mobile.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      usabts: file(relativePath: { eq: "bts/calendar-15-back-to-school.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      usabtsMobile: file(relativePath: { eq: "bts/calendar-15-back-to-school-mobile.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundMobile: file(relativePath: { eq: "homepage/calendar-on-counter-mobile.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundMobileMD: file(
        relativePath: { eq: "homepage/calendar-on-counter-mobile-md.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundCalendarMobileMD: file(
        relativePath: { eq: "homepage/calendar-on-counter-calendar-mobile-md.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      google: file(relativePath: { eq: "icons/google.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      outlook: file(relativePath: { eq: "icons/outlook.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      apple: file(relativePath: { eq: "icons/apple.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      cozi: file(relativePath: { eq: "icons/cozi.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      yahoo: file(relativePath: { eq: "icons/yahoo.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      link: file(relativePath: { eq: "external-link.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE)
        }
      }
    }
  `)

  const calendarList = [
    { id: 'google', label: 'Google' },
    { id: 'outlook', label: 'Outlook' },
    { id: 'apple', label: 'Apple' },
    { id: 'cozi', label: 'Cozi' },
    { id: 'yahoo', label: 'Yahoo' },
  ]
  const {
    store: {
      banner: { promoCode },
    },
  } = useContext(StoreContext)
  const HEADING_OVERRIDE = {
    calendar: 'Drop the Stress. Not the Ball.',
    bts: 'Skylight Runs the School Year',
    frame2: 'Perfect in Every Room',
  }
  const SUBHEADING_OVERRIDE = {
    calendar:
      'Get the whole family organized with scheduling, meal planning, chore charts and customizable lists — all on one beautiful display.',
    bts: 'Keep first day memories, supply lists, & class schedules top-of-mind with our  digital calendars and photo frames.',
    frame2:
      "Our best-selling smart photo frame just got even better. And with our new Snap Frames, you don't have to choose a color - you can have them all.",
  }

  const DESKTOP_IMAGE_OVERRIDE = {
    calendar: data.calBackgroundCalendarMD.childImageSharp.gatsbyImageData,
    bts: data.bts.childImageSharp.gatsbyImageData,
    frame2: data.frame2Background.childImageSharp.gatsbyImageData,
  }
  let image =
    DESKTOP_IMAGE_OVERRIDE[page] ||
    DESKTOP_IMAGE_OVERRIDE[promoCode] ||
    (!IS_FOREIGN_COUNTRY
      ? data.usabts.childImageSharp.gatsbyImageData
      : data.bts.childImageSharp.gatsbyImageData)

  const MOBILE_IMAGE_OVERRIDE = {
    calendar: data.calBackgroundCalendarMD.childImageSharp.gatsbyImageData,
    bts: data.btsMobile.childImageSharp.gatsbyImageData,
    frame2: data.frame2MobileBackground.childImageSharp.gatsbyImageData,
  }
  let mobileImage =
    MOBILE_IMAGE_OVERRIDE[page] ||
    MOBILE_IMAGE_OVERRIDE[promoCode] ||
    (IS_FOREIGN_COUNTRY
      ? data.btsMobile.childImageSharp.gatsbyImageData
      : data.usabtsMobile.childImageSharp.gatsbyImageData)

  if (!IS_FOREIGN_COUNTRY && page === 'calendar') {
    image = data.calBackground.childImageSharp.gatsbyImageData
    mobileImage = data.calBackgroundMobile.childImageSharp.gatsbyImageData
  }
  const CTA_OVERRIDE = { calendar: 'Buy Now', frame2: 'Buy Now' }
  const getAmazonLink = () => {
    if (IN_CA) return 'https://urlgeni.us/amazon/DH2zq'
    if (IN_UK) return 'https://urlgeni.us/amazon/UK-Shopify'
    if (IN_AU) return 'https://urlgeni.us/amazon/AU-Shopify'
    return 'https://urlgeni.us/amazon/ShopifyCal15Amazon'
  }

  const AMAZON_LINK = getAmazonLink()
  return (
    <Container>
      <HiddenOnDesktop>
        <ImageContainer>
          <GatsbyImage
            image={mobileImage}
            alt='Skylight Calendar 15" on a countertop with a plant and bookcase in the background'
          />
        </ImageContainer>
      </HiddenOnDesktop>
      <TextContainer singleSlide>
        <YotpoStars
          color={theme.orange}
          textcolor="#444444"
          productId={page === 'frame2' ? '7073751498804' : '6863425175604'}
        />
        <Heading small={page === 'calendar'}>
          {HEADING_OVERRIDE[page] ||
            HEADING_OVERRIDE[promoCode] ||
            'The All-In-One Smart Family Calendar'}
        </Heading>
        <SubHeading>
          {SUBHEADING_OVERRIDE[page] ||
            SUBHEADING_OVERRIDE[promoCode] ||
            'Get the whole family organized with scheduling, meal planning, chore charts and customizable lists — all on one beautiful display.'}
        </SubHeading>
        <Flexbox>
          <CtaContainer gap>
            {amazon && (
              <BuyNowAnchor
                href={AMAZON_LINK}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => Analytics.track('Clicked to Amazon Calendar')}
              >
                Buy Now on Amazon
                <ExternalLink
                  image={data.link.childImageSharp.gatsbyImageData}
                  alt="external link"
                />
              </BuyNowAnchor>
            )}
            <BuyNowLink
              onClick={() =>
                Analytics.track(
                  page === 'frame2'
                    ? 'Clicked Buy Now Frame 2 Hero on Frame 2 CTA'
                    : 'Clicked Buy Now Calendar Hero on Homepage CTA'
                )
              }
              to={page === 'frame2' ? FRAME_2_WALNUT_BUY_LINK : CAL_BUY_LINK}
            >
              {CTA_OVERRIDE[page] || 'Shop Calendar'}
            </BuyNowLink>
            {IS_FOREIGN_COUNTRY && page !== 'calendar' && promoCode !== 'VIPBTS' && (
              <BuyNowLink
                onClick={() => Analytics.track('Clicked Buy Now Frame Hero on Homepage CTA')}
                to={page === 'frame2' ? FRAME_2_WALNUT_BUY_LINK : BUY_LINK}
              >
                {CTA_OVERRIDE[page] || 'Shop Frame'}
              </BuyNowLink>
            )}
          </CtaContainer>
          {page !== 'frame2' && (
            <SyncsSection>
              <SyncsHeader>Seamlessly auto-syncs with:</SyncsHeader>
              <CtaContainer>
                {calendarList.map(({ id, label }) => (
                  <LogoImageContainer>
                    <GatsbyImage
                      key={id}
                      image={data[id].childImageSharp.gatsbyImageData}
                      alt={`Skylight Calendar is compatible with ${label}`}
                    />
                  </LogoImageContainer>
                ))}
              </CtaContainer>
            </SyncsSection>
          )}
        </Flexbox>
      </TextContainer>
      <HiddenOnMobile>
        <ImageContainer>
          <GatsbyImage
            image={image}
            alt='Skylight Calendar 15" on a countertop with a plant and bookcase in the background'
          />
        </ImageContainer>
      </HiddenOnMobile>
    </Container>
  )
}

HomepageCalHero.propTypes = {
  page: PropTypes.string.isRequired,
  amazon: PropTypes.bool,
}
